export default "__VITE_ASSET__FJ4UCExD__"